import {CupTeamSeason} from '../resources/CupTeamSeason';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the
 * {@see CupTeamSeasonsExportRequested} event is available and can be processed.
 */
export class CupTeamSeasonsExportAvailable extends EntityExportAvailableEvent<CupTeamSeason> {
}
